import React from 'react';
import PropTypes from 'prop-types';
import { VCIboxContent } from './vciBoxContent';
import { FieldCard } from '../../GoogleMap/styles';

export const VCIbox = (props) => {
  const { fieldInfo, fieldArea } = props;
  return (
    <FieldCard>
      <VCIboxContent fieldInfo={fieldInfo} fieldArea={fieldArea} />
    </FieldCard>
  );
};

VCIbox.propTypes = {
  fieldInfo: PropTypes.any,
  fieldArea: PropTypes.any
};
